
import { ChildrenNodeType } from '@/shared/types/children';
import styles from './CardMain.module.scss';

type Props = {
  title: string;
  children: ChildrenNodeType;
}

const CardMain = ({ title, children }: Props) => {

  return (
    <section className={styles.root}>
      <header className={styles.header}><h2 className={styles.headerTitle}>{title}</h2></header>
      <section className={styles.content}>{children}</section>
      {/* <footer className={styles.footer}> */}
        
      {/* </footer> */}
    </section>
  );
};

export { CardMain };